// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Hero_hero__zvVCj {
  background: #000;
  /* background: linear-gradient(180deg, #19b16a 0%, #00934c 100%); */
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: relative;
}
.Hero_heroInner__kpa3R {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 500px;
  width: 100%;
  position: absolute;
  margin-top: 42px;
}
.Hero_promotionBadge__kgMub {
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  margin-top: 16px;
  position: absolute;
  bottom: 40%;
}
.Hero_title__rL9MQ {
  color: #fff;
  text-align: center;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
}

.Hero_text__ht4xS {
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  margin: 12px 0;
}

.Hero_info__HKZhn {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 8px 24px;
  margin-bottom: 24px;
  background: rgba(0, 0, 0, 0.17);
  -webkit-backdrop-filter: blur(40px);
          backdrop-filter: blur(40px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.16);
  border-top: 1px solid rgba(255, 255, 255, 0.16);
}
.Hero_infoIitems__wmrvw {
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.16);
}
.Hero_infoDesc__zehMO {
  display: flex;
  margin-top: 8px;
  flex-direction: column;
}
.Hero_infoIitem__XwSIH {
  display: flex;
  justify-content: center;
  align-items: center;
}
.Hero_dot__oCJ4V {
  width: 4px;
  height: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  border-radius: 50%;
  margin: 0 10px;
}
.Hero_infoText__NBpxK {
  color: #fff;
  text-align: center;
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
}
.Hero_image__zL6bt {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.Hero_image__zL6bt img {
  width: 100%;
  min-width: 375px;
  min-height: 256px;
  max-width: 500px;
}

@media screen and (min-width: 1000px) {
  .Hero_hero__zvVCj {
  }
  .Hero_text__ht4xS {
    font-size: 16px;
  }
  .Hero_infoText__NBpxK {
    font-size: 14px;
  }
  .Hero_image__zL6bt {
    height: unset;
  }
  .Hero_image__zL6bt img {
    min-width: 1200px;
    min-height: 332px;
    max-width: unset;
  }
  .Hero_promotionBadge__kgMub {
    background: rgba(0, 0, 0, 0.17);
    -webkit-backdrop-filter: blur(40px);
    backdrop-filter: blur(40px);
    padding: 6px;
    font-weight: 600;
    bottom: 56%;
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Hero/Hero.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mEAAmE;EACnE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,mCAA2B;UAA3B,2BAA2B;EAC3B,kDAAkD;EAClD,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kDAAkD;AACpD;AACA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;EACA;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,+BAA+B;IAC/B,mCAAmC;IACnC,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":[".hero {\n  background: #000;\n  /* background: linear-gradient(180deg, #19b16a 0%, #00934c 100%); */\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  position: relative;\n}\n.heroInner {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  max-width: 500px;\n  width: 100%;\n  position: absolute;\n  margin-top: 42px;\n}\n.promotionBadge {\n  color: #fff;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 22px;\n  margin-top: 16px;\n  position: absolute;\n  bottom: 40%;\n}\n.title {\n  color: #fff;\n  text-align: center;\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 36px;\n}\n\n.text {\n  color: #fff;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 22px;\n  margin: 12px 0;\n}\n\n.info {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n  padding: 8px 24px;\n  margin-bottom: 24px;\n  background: rgba(0, 0, 0, 0.17);\n  backdrop-filter: blur(40px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.16);\n  border-top: 1px solid rgba(255, 255, 255, 0.16);\n}\n.infoIitems {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: fit-content;\n  padding-bottom: 8px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.16);\n}\n.infoDesc {\n  display: flex;\n  margin-top: 8px;\n  flex-direction: column;\n}\n.infoIitem {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.dot {\n  width: 4px;\n  height: 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #fff;\n  border-radius: 50%;\n  margin: 0 10px;\n}\n.infoText {\n  color: #fff;\n  text-align: center;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px;\n}\n.image {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n.image img {\n  width: 100%;\n  min-width: 375px;\n  min-height: 256px;\n  max-width: 500px;\n}\n\n@media screen and (min-width: 1000px) {\n  .hero {\n  }\n  .text {\n    font-size: 16px;\n  }\n  .infoText {\n    font-size: 14px;\n  }\n  .image {\n    height: unset;\n  }\n  .image img {\n    min-width: 1200px;\n    min-height: 332px;\n    max-width: unset;\n  }\n  .promotionBadge {\n    background: rgba(0, 0, 0, 0.17);\n    -webkit-backdrop-filter: blur(40px);\n    backdrop-filter: blur(40px);\n    padding: 6px;\n    font-weight: 600;\n    bottom: 56%;\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hero": `Hero_hero__zvVCj`,
	"heroInner": `Hero_heroInner__kpa3R`,
	"promotionBadge": `Hero_promotionBadge__kgMub`,
	"title": `Hero_title__rL9MQ`,
	"text": `Hero_text__ht4xS`,
	"info": `Hero_info__HKZhn`,
	"infoIitems": `Hero_infoIitems__wmrvw`,
	"infoDesc": `Hero_infoDesc__zehMO`,
	"infoIitem": `Hero_infoIitem__XwSIH`,
	"dot": `Hero_dot__oCJ4V`,
	"infoText": `Hero_infoText__NBpxK`,
	"image": `Hero_image__zL6bt`
};
export default ___CSS_LOADER_EXPORT___;
